<template>
	<div class="container-fluid d-flex justify-content-between flex-column flex-md-row">

		<!-- products section -->
		<section class="products-section pb-5 mb-3">
			<div class="h-100">
				<div class="d-flex mt-5 mb-2 products-section-header">
					<h4 class="mb-2 mx-2">{{ $t('navbar.products') }}</h4>
					<span class="mx-2 bold" v-if="$route.params.slug">( {{categories.find(c => c.slug === $route.params.slug)?.name}} )</span>
					<i v-if="$route.params.slug" class="fa-solid fa-xmark pointer" @click="$router.push({name: 'all-products'})"></i>
				</div>
				<div class="w-100 d-flex flex-wrap">
					<router-link
						v-for="item in currentProducts"
						:key="item.id"
						class="product-card-block mb-4 router-link-class"
						:to="{ name: 'product', params: { slug: item.slug } }"
					>
						<div class="px-3 py-3 rounded-top-4 bg-white card-shadow card-content-height">
							<!-- content -->
							<div class="d-flex flex-column justify-content-between text-center h-100">
								<div class="product-image pb-2">
									<img :src="item?.primaryImage.url" alt="" class="rounded-3" width="fit-content" height="100%">
								</div>
								<div class="d-flex flex-column justify-content-center align-items-center w-100 h-100">
									<div class="product-name bold d-flex align-items-center mb-auto">
										{{item.name}}
									</div>
									<div class="product-attributes pt-2 d-flex justify-content-center">
										<div class="d-flex">
											<div v-if="item.attributes.some(c => c.type === 13)" class="d-flex align-items-center">
												<div class="d-flex align-items-center">
													<div
														v-for="(element, i) in filterAttributeValues(item.attributes.find(c => c.type === 13))"
														:key="i"
														:style="{ backgroundColor: element, width: '10px', height: '10px', borderRadius: '50%', margin: '0px 2px', border: '1px solid grey' }"
													>
													</div>
													<div v-if="item.attributes.find(c => c.type === 13)?.values.length > 4" style="margin: 0 2px">+</div>
												</div>
											</div>
										</div>
										<span v-if="item.attributes.length > 1" class="px-2 text-center" style="color: grey">|</span>
										<div class="d-flex justify-content-center">
											<div class="v-html-content content-elipse" v-html="item.attributes.find(c => c.type !== 13)?.value"></div>
											<img v-if="item.attributes.find(c => c.type !== 13)?.image?.url" :src="item.attributes[1]?.image?.url" alt="" class="px-1" width="25">
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- eye -->
							<div class="w-100 rounded-bottom-4 text-center product-card-eye d-flex align-items-center justify-content-center">
								<i class="fa-solid fa-eye"></i>
							</div>
					</router-link>
				</div>
			</div>
		</section>

		<!-- tabs section -->
		<div class="mt-5 tabs-section">
			<h4 class="mb-3">{{ $t('navbar.categories') }}</h4>
			<div class="tabs">
				<div class="list-group">
					<div
						class="list-group-item list-group-item-action pointer"
						:class="{ 'active': !$route.params.slug }"
						@click="$router.push({name: 'all-products'})"
					>
						{{$t('all-categories')}}
					</div>
				</div>
				<div class="list-group" v-for="item in categories" :key="item.id">
					<div
						class="list-group-item list-group-item-action pointer"
						:class="{'active': activeCategory === item.slug}"
						@click="$router.push({name: 'all-products', params: {slug: activeCategory === item.slug ? null : item.slug}});"
					>
						{{item.name}}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { filterAttributeValues } from '@/helpers/functions';
export default {
	name: 'AllProducts',
	data () {
		return {
			activeCategory: null,
			currentProducts: [],
			productsTest: [
				{
					id: 1,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 2,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 3,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 4,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 5,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 6,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 7,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 8,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 9,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 10,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 11,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 12,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 13,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 14,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 15,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 16,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 17,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 18,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 19,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				},
				{
					id: 20,
					name: 'برغي توركس',
					attributes: {
						attr1: '12',
						attr2: '13',
					},
					image: require('@/assets/images/screw-product.png'),
					to: '/product/1'
				}
			],

			tabs: [
				{
					id: 1,
					name: 'براغي خشبية'
				},
				{
					id: 2,
					name: 'براغي PVC'
				},
				{
					id: 3,
					name: 'براغي حديد'
				}
			]
		}
	},

	watch: {
		'$route' (newVal) {
			this.activeCategory = newVal.params.slug
			if (this.$route.params.slug) {
				const currentCategoryId = this.categories.find(c => c.slug === this.$route.params.slug).id
				this.currentProducts = this.products.filter(c => c.categoriesIds[0] === currentCategoryId)
			} else {
				this.currentProducts = this.products
			}
		}
	},

	computed: {
		...mapState({
			categories: state => state.categories.categories,
			products: state => state.products.products,
		}),
	},

	methods: {
		filterAttributeValues
	},

	mounted () {
		this.$emit('loading', true)
		const promises = [];

		if (this.products?.length === 0) {
			promises.push(this.$store.dispatch('products/fetchAllProducts'));
		}

		Promise.all(promises).then(() => {
			this.activeCategory = this.$route.params.slug;

			// filling the products behavior
			if (this.$route.params.slug) {
				const currentCategoryId = this.categories.find(c => c.slug === this.activeCategory).id
				this.currentProducts = this.products.filter(c => c.categoriesIds[0] === currentCategoryId)
			} else {
				this.currentProducts = this.products
			}
			this.$emit('loading', false)
		})
	}
}
</script>

<style lang="scss" scoped>
@import '../scss/vars.scss';
// major classes
.section-title {
	font-weight: 800;
	line-height: 1.65;
}

.section-title ::v-deep span {
	color: $secondary;
	font-weight: 900;
}

.container-flex {
	@media (max-width: 678px) {
		flex-direction: column;
	}
}

.products-section {
	width: 75%;
	order: 1;

	@media (max-width: 768px) {
		width: 100%;
		order: 2;
	}

	.products-section-header {
		span {
			color: $secondary;
			display: flex;
			justify-content: center;
			align-items: end;
			margin-bottom: 10px
		}
		i {
			color: #bbbbbb;
			font-size: 10px;
			display: flex;
			justify-content: center;
			align-items: end;
			margin-bottom: 15px
		}
	}
	.product-card-block {
		@media (min-width: 1600px) {
			width: 15%
		}

		width: 18%;
		margin: 0 7px;

		@media (max-width: 1200px) {
			width: 23%;
			margin: 0 5px;
		}
		@media (max-width: 992px) {
			margin: 0 3px;
		}

		@media (max-width: 925px) {
			width: 30%;
			margin: 0 8px;
		}

		@media (max-width: 568px) {
			width: 47%;
			margin: 0 5px;
		}

		@media (max-width: 375px) {
			margin: 0 auto;
		}

		@media (max-width: 359px) {
			width: 97%;
		}

		.product-image {
			height: 125px;
		}

		.product-name {
			font-size: 14px;
		}

		.product-attributes {
			font-size: 13px;
		}

		.card-content-height {
			height: 87.5%
		}

		transition: transform 0.15s ease, box-shadow 0.15s ease;
		&:hover {
			transform: translateY(-3px);
		}
	}

	.product-card-eye {
		background-color: $primary;
		height: 30px;
		color: white;
	}
}

.tabs-section {
	width: 25%;
	order: 2;

	@media (max-width: 768px) {
		width: 100%;
		order: 1;
	}

	.tabs {
		display: flex;
		flex-direction: column;

		@media (max-width: 768px) {
			flex-direction: row;
			flex-wrap: wrap;
		}
	}
}
// .nav-link {
// 	color: black;
// 	font-weight: bold;
// 	border-radius: 0;
// }
// .nav-link .active {
// 	background-color: transparent;
// 	color: $secondary;
// 	border-bottom: 1px solid $secondary;
// }

.active {
	background-color: $secondary;
	border: 1px solid $secondary;
}
</style>

<style lang="scss" scoped>
.content-elipse {
	font-size: 12px;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>